module.exports = __webpack_public_path__ + "static/media/icon-atsl.d32d6f96.svg";